/* eslint-disable simple-import-sort/imports */
import "../../components/welcomeScreen/welcome.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React from "react";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import WelcomeFilesListView from "../../components/welcomeScreen/WelcomeFilesListView";
import PubSubTopics from "../../constants/pubSubTopics";
import { welcomeSelectors } from "../../modules/welcome";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { PropTypeShapes } from "../../types";
import { wrapEditingComponent } from "../../utils/codeSplit";
import { trackEvent } from "../../utils/trackAnalytics";

//#!if ENV !== "production"
// import { loadInternalData } from "../../testInBrowser/internalLoader";
//#!endif

const onFileClick = filePath => {
  trackEvent("loadRecentFile", "load", filePath);

  if (isNativeCommsInstalled()) {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.WELCOME_RECENT_FILE_OPENED,
      fullPath: filePath
    });
  } else {
    //#!if ENV !== "production"
// loadInternalData(filePath);
    //#!endif
  }
};

const WelcomeLeftContainer = props => {
  return (
    <div className="welcomeLeftContainer">
      {wrapEditingComponent(<FormButton primary={true} label="Create new..." onClick={props.onCreateNew} />)}
      <FormButton label="Open..." onClick={props.onOpenExistingFile} />
      <div className="welcomeOpenFileView">
        <div className="welcomeRecentFilesContainerTitle">Recent Files</div>
        <WelcomeFilesListView fileList={props.recentFiles} onFileClick={onFileClick} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    recentFiles: welcomeSelectors.getRecentFiles(state.present)
  };
};

WelcomeLeftContainer.propTypes = {
  recentFiles: PropTypeShapes.fileRecordList.isRequired,
  onCreateNew: PropTypes.func.isRequired,
  onOpenExistingFile: PropTypes.func.isRequired
};

export default connect(mapStateToProps, null)(WelcomeLeftContainer);
